export default {
    chat: {
    // タイトル
        title: 'チャット',
        hiroTitle: 'Hiro',
        hiroSubtitle: '作成アシスタント',
        figuresSubtitle: '図表アシスタント',
        taskProcessing: 'タスク処理中',
        planDefaultTitle: '実行計画',
        planStepFallback: 'ステップ {index}',
        planTypes: {
            Free: '無料版',
            Internal: '内部版',
            Pro: 'Pro',
            Enterprise: 'エンタープライズ版',
        },

        // ウェルカムページ
        welcome: {
            title: 'こんにちは！私は Hiro です',
        },
        hiroIntro: 'あなたのインテリジェント特許作成アシスタントとして、特許出願書類の作成と審査を効率的に完了できるようサポートします。',
        disclaimer: 'AI生成、参考用',
        readOnlyWarning: '権限不足：読み取り専用権限のみです',

        // 空の状態
        empty: {
            tryExamples: 'クイックスタート - これらの例を試してみてください',
        },

        // 後端タスク状態
        taskStatus: {
            PENDING: '実行待ち',
            STARTED: '実行中',
            SUCCESS: '完了',
            FAILURE: '実行失敗',
            RETRY: 'リトライ中',
            REVOKED: 'キャンセル済み',
            INTERRUPTED: '中断されました',
        },

        // 例題
        examples: [
            'スマートフォンの折りたたみ画面技術に関する発明特許出願の作成を手伝ってください',
            'この OA 通知書の審査意見を分析してください',
            'クレームの作成を最適化して、より明確で完全なものにしてください',
            '技術開示書に基づいて明細書を生成してください',
        ],

        // 図面 Agent ウェルカムページ
        figuresIntro: '特許図面生成アシスタントとして、特許文書に基づいて特許図面を自動的に計画・作成します。',
        figuresExamples: [
            '既存の資料に基づいて図面を計画してください',
            'クレームの主要な技術的特徴の構造図を生成してください',
            '既存の図面を特許基準に合わせて最適化してください',
            '技術開示書に基づいて図面リストを生成してください',
        ],

        // 入力ボックス
        input: {
            placeholder: {
                default: 'メッセージを入力... {\'@\'} で参照を追加、/ でクイックコマンド',
                disabled: '入力が無効です。しばらくお待ちください...',
                sending: 'メッセージを送信中...',
            },
            placeholderDisabled: 'Hiro が現在のタスクを完了するまでお待ちください...',
            placeholderWaiting: '応答を待っています...',
            send: '送信',
            stop: '停止',
            waiting: '処理中',
            selectedText: '選択されたテキスト',
            clearSelection: '選択をクリア',
            disabledFooter: 'Hiro が処理中です。お待ちください...',
            keys: {
                instruct: '指示',
                generate: '生成',
                edit: '編集',
                upload: 'アップロード',
            },
            workMode: {
                agent: 'エージェント',
                copilot: 'コパイロット',
            },
            upgrade: 'アップグレード',
        },

        // ファイルアップロード
        upload: {
            filePromptSuffix: 'これらのファイルを読み、内容が現在のタスクに与える影響をまとめ、次のステップの提案を生成してください。',
        },

        // チャット履歴
        history: {
            title: 'チャット履歴',
            empty: 'チャット履歴がありません',
            search: '会話を検索',
            rename: '名前を変更',
            delete: '削除',
            defaultTitle: '新しいチャット',
            deleteConfirm: 'この会話を削除してもよろしいですか？',
            inputErrorMessage: '会話タイトルを入力してください',
            renameSuccess: '名前を変更しました',
            // 日付グループラベル
            today: '今日',
            yesterday: '昨日',
            lastWeek: '過去7日間',
            lastMonth: '過去30日間',
            older: 'それ以前',
        },

        // アクションボタン
        actions: {
            copy: 'コピー',
            copySuccess: 'クリップボードにコピーしました',
            copyFailed: 'コピーに失敗しました',
            mergeToDocument: 'ドキュメントにマージ',
            mergeToDocumentTooltip: 'この内容を現在のドキュメントにマージする',
            newChat: '新しいチャット',
            selectLanguage: 'AI出力言語を設定',
            languageLabel: 'モデル出力言語',
            expandFullContent: '展開して全文を表示',
        },

        newChatConfirm: {
            message: 'Hiroは新しいチャットを開始し、現在のチャット履歴をChat Historyに保存します。',
        },

        // タスク未完了リマインダー
        incompleteTasksDialog: {
            title: 'タスクが未完了です',
            description: '現在のタスク計画にはまだ未完了のステップがあります：',
            bannerText: 'タスクが一時停止中 — 未完了のステップがあります',
            completedLabel: '完了',
            incompleteLabel: '未完了',
            continueBtn: 'タスクを続ける',
            endBtn: 'タスクを終了',
            continueMessage: '残りのタスクステップを続けてください',
            endMessage: 'すべてのタスク計画ステップを完了済みとしてマークし、その後タスクを終了してください。',
            inputPlaceholder: '補足説明（任意）',
        },

        // メッセージ
        messages: {
            sendFailed: 'メッセージの送信に失敗しました。もう一度お試しください',
            connecting: 'チャットに接続しています...',
            applyingTemplate: 'テンプレートを適用しています...',
            templateAppliedSuccess: 'テンプレートを正常に適用しました：{name}',
            templateApplyFailed: 'テンプレートの適用に失敗しました。もう一度お試しください',
            editorNotInitialized: 'エディタが初期化されていません。テンプレートを適用できません',
            loadHistoryFailed: '会話履歴の読み込みに失敗しました',
            createFailed: '会話の作成に失敗しました',
            deleteFailed: '会話の削除に失敗しました',
            renameFailed: '会話の名前変更に失敗しました',
            permissionDenied: '現在、{agentName} を使用する権限がありません。プランをアップグレードするには営業担当者にお問い合わせください。',
            permissionDeniedOverseas: '現在、{agentName} を使用する権限がありません。{upgradeLink}してください。',
            upgradePlan: 'プランをアップグレード',
            limitExceeded: '使用制限に達しました。プランをアップグレードするか、明日もう一度お試しください。',
            limitExceededOverseas: '使用制限に達しました。{upgradeLink}するか、明日もう一度お試しください。',
            limitExceededGuest: '使用制限に達しました。サインアップするか、明日もう一度お試しください。',
            taskInProgress: '別のタスクが実行中です。完了するまでお待ちください。',
            globalTaskLimitExceeded: 'システムの負荷が高くなっています。しばらくしてからもう一度お試しください。',
            interruptFailed: 'タスクの中断に失敗しました。もう一度お試しください',
            contentFilter: '入力内容に不適切な言葉が含まれています。修正してから再試行してください。',
            modeChanged: '作業モードが切り替わりました',
            modeChangeFailed: '作業モードの切り替えに失敗しました',
            modeSwitchNotice: '{from} モードから {to} モードに切り替えました',
        },

        // 入力欄ステータスバー
        composerStatus: {
            idle: '入力をお待ちしています…',
            sending: '考え中…',
            running: '実行中…',
            runningWithEstimate: '実行中、経過 {elapsed}、目安 {estimated}',
            runningWithElapsed: '実行中、経過 {elapsed}',
            runningLongTask: '複数ステップの作成タスクを処理中',
            runningWithRemaining: '残り約 {remaining}',
            runningFinalizing: '仕上げ中…',
            runningMetaWithEstimate: '経過 {elapsed} · 進行に応じて目安を更新します',
            runningMetaWithElapsed: '経過 {elapsed}',
            interrupting: '中断中…',
        },

        duration: {
            seconds: '{count} 秒',
            minutes: '{count} 分',
            minutesSeconds: '{minutes} 分 {seconds} 秒',
        },

        browserNotification: {
            completedTabTitle: 'Hiro のタスクが完了しました',
            failedTabTitle: 'Hiro のタスクが失敗しました',
            inputRequiredTabTitle: 'Hiro が入力を待っています',
            completedTitle: 'Hiro のタスクが完了しました',
            completedBody: '現在の作成タスクが完了しました。戻って結果を確認できます。',
            failedTitle: 'Hiro のタスクが失敗しました',
            failedBody: '現在の作成タスクは完了しませんでした。戻って詳細を確認してください。',
            inputRequiredTitle: 'Hiro が入力を待っています',
            inputRequiredBody: '現在のタスクを続行するには、確認または追加情報が必要です。',
        },

        // Agent タイプ名
        agentTypes: {
            disclosure: '技術開示書',
            prosecution: '審査意見への対応',
            patent_draft: '特許作成',
        },

        // 指示
        instructions: {
            select: '指示を選択',
            refresh: '指示リストを更新',
            searchPlaceholder: '指示を検索...',
            noResults: '指示が見つかりません',
            suggestionsTitle: '推奨される指示',
            useThis: 'この指示を使用',
            navigate: '指示センターへ移動',
            instructionContent: '指示内容',
            description: '説明',
            tags: 'タグ',
            jurisdiction: '管轄',
            createdAt: '作成日時',
            exampleOutput: '出力例',
            close: '閉じる',
        },

        // 保留状態
        pending: {
            title: '入力が必要です',
            subtitle: 'Hiro は続行するためにさらに情報が必要です',
            inputLabel: 'あなたの回答',
            waitingInfo: '確認または入力をお待ちしています',
            tools: {
                askUser: 'ユーザーに尋ねる',
                task: 'タスク確認',
                todoWrite: 'To-Do アイテム',
            },
        },

        // 決定フォーム
        decisionForm: {
            multiSelectHint: '(複数選択可)',
            inputPlaceholder: '入力してください...',
            questionAdditionalPlaceholder: '補足説明があればこちらに入力してください...',
            submitted: '送信済み',
            submit: '送信',
            cancel: 'キャンセル',
            loading: '決定フォームを読み込み中...',
            parseError: '⚠️ 決定フォームのデータ形式エラー',
        },

        // 指示フォーム
        instructionForm: {
            kicker: '指示フォーム',
            fieldCount: '{count} 件のフィールド',
            instructionContent: '指示内容',
            instructionContentPlaceholder: '今回 AI に送信する指示内容を編集できます',
            inputPlaceholder: '入力してください...',
            selectPlaceholder: '選択してください',
            extraRequirement: '追加要件',
            extraRequirementPlaceholder: 'この指示を使う際に AI に考慮してほしい情報を追加できます',
            extraRequirementInline: '具体的な要件を追加',
            directRun: 'そのまま実行',
            charCount: '{count} 文字',
            recognizedInstruction: '「{name}」プリセット指示を認識しました',
            detail: '詳細',
            requiredError: '「{label}」を入力してください',
            emptyValue: '未入力',
            submit: '送信',
            submitted: '送信済み',
            cancel: 'キャンセル',
            cancelled: 'キャンセル済み',
            parseError: '指示フォームのデータ形式エラー',
            yes: 'はい',
            no: 'いいえ',
            outputInstructionName: '指示名',
            outputInstructionDescription: '指示の説明',
            outputInstructionContent: '指示内容',
            outputUserInputs: '追加要件',
            outputFieldDescription: 'フィールド説明',
            outputUserAnswer: '追加要件',
            optionSourceClaims: '請求項',
            optionSourceFigures: '図面',
            optionSourceSelect: '{source}を選択',
            optionSourceReselect: '{source}を再選択（{count} 件選択済み）',
            optionSourceTitle: '{source}を選択',
            optionSourceHint: '現在の文書から選択可能な内容を解析し、選択した内容を追加要件として AI に送信します。',
            optionSourceRefresh: '再解析',
            optionSourceLoading: '文書内容を解析中...',
            optionSourceEmpty: '{source}が見つかりません',
            optionSourceNoDocument: '解析可能な文書内容が見つかりません',
            optionSourceFailed: '解析に失敗しました',
            optionSourceRetry: '再試行',
            optionSourceConfirm: '選択を確定',
        },

        // テンプレートセクションフォーム
        templateSectionForm: {
            kicker: 'テンプレートセクションフォーム',
            sourceTemplate: '元テンプレート：{name}',
            sectionPrompt: 'セクション指示内容',
            sectionPromptPlaceholder: '今回 AI に送信するセクション指示内容を編集できます',
            extraRequirementPlaceholder: 'このセクション生成時に AI に考慮してほしい情報を追加できます',
            recognizedSection: '「{name}」セクション指示を認識しました',
            parseError: 'テンプレートセクションフォームのデータ形式エラー',
            outputSectionPrompt: 'セクション指示内容',
            sectionNames: {
                TITLE: '発明の名称',
                BACKGROUND: '背景技術',
                SUMMARY_OF_INVENTION: '発明の概要',
                BRIEF_DESCRIPTION_OF_FIGURES: '図面の簡単な説明',
                CLAIMS: '特許請求の範囲',
                ABSTRACT: '要約',
                DETAILED_DESCRIPTION: '発明を実施するための形態',
                DETAILED_DESCRIPTION_PLAN: '実施形態のアウトライン',
                REPEAT_CLAIMS: '請求項の繰り返し',
                CUSTOM: 'カスタムセクション',
            },
        },

        templateSectionPopover: {
            title: 'テンプレートセクション指示',
            close: '閉じる',
            insert: '左側の文書に挿入',
            apply: '適用',
            instruction: 'AI 指示',
            noInstruction: 'AI 指示が設定されていません',
            fromLibrary: 'ライブラリから選択',
            remove: '削除',
            addSection: 'セクションを追加',
            newSection: '新しいセクション',
            empty: '現在の文書で利用できるテンプレートセクションはありません',
            chars: '文字',
            fields: 'フィールド',
        },

        // タスク提案
        suggestions: {
            title: 'タスク提案',
            agentLabels: {
                novelty: '特許新規性調査エージェント',
            },
        },

        // 参照コンテンツ
        reference: {
            label: '選択したコンテンツを参照',
        },

        // 中断
        interrupting: {
            title: '実行を停止中',
            description: '現在のタスクを安全に終了しています...',
            interrupted_by_user: 'ユーザーによって実行が中断されました',
            processing: '処理中...',
        },

        // エラーメッセージ
        error: {
            technicalDetails: '技術詳細（開発環境のみ）',
            errorCode: 'エラーコード：',
            permissionDeniedReadOnly: '読み取り専用権限のため、メッセージを送信できません',
            permissionDeniedEdit: 'サンプルプロジェクトは読み取り専用です。自分の編集可能なバージョンを{createLink}してください',
            createLink: '作成',
            permissionDeniedDelete: '削除する権限がありません',
            permissionDeniedNoAccess: 'このリソースへのアクセスが拒否されました',
        },

        // タスクリスト
        tasks: {
            completed: '完了',
            markComplete: '完了としてマーク',
            collapse: 'タスクリストを折りたたむ',
            expand: 'すべてのタスクを表示',
        },

        // ツール関連
        toolCall: {
            result: 'ツール結果を表示',
            toolResultLabel: 'ツール結果',
            toolResultHint: 'これはツール実行の中間出力です。最終版は「ドキュメント」タブでご確認ください。',
            parameterDetails: 'パラメータ詳細',
            executing: '実行中...',
            expand: '詳細を展開',
            collapse: '折りたたむ',
            betaBadge: 'Beta',
            spawnSteps: '{count} 個のサブステップ',
        },

        toolGroup: {
            title: '{title} など {count} ステップ',
            stepCount: '{count} ステップ',
            completedCount: '完了 {count}',
            runningCount: '実行中 {count}',
            failedCount: '失敗 {count}',
        },

        // 画像プレビュー
        imagePreview: {
            generatedImage: 'AI 生成画像',
            zoomIn: '拡大',
            zoomOut: '縮小',
            download: 'ダウンロード',
            close: '閉じる',
        },

        // 図面生成
        imageGeneration: {
            title: '図面生成分析',
            promptLabel: '生成プロンプト',
            imagePreview: '生成結果',
            noImage: '生成画像がありません',
            failedTitle: '画像生成に失敗しました',
            timeoutError: '画像生成がタイムアウトしました。しばらくしてからもう一度お試しください。',
            genericError: '画像生成に失敗しました。しばらくしてからもう一度お試しください。',
        },

        // ツール名
        tools: {
            unknown: 'ツール呼び出し',
            timeUnknown: '--:--',
            get_current_time: '現在時刻を取得',
            create_document: 'ドキュメントを作成',
            read_document: 'ドキュメントを読む',
            list_project_attachments: 'プロジェクト添付ファイルをリスト',
            read_attachment_content: '添付ファイルを読む',
            read_image: '画像を読む',
            auto_annotate_image: '画像を自動注釈',
            intelligent_patent_search: '知的特許検索',
            get_patent_details: '特許詳細を取得',
            paper_semantic_search: '論文セマンティック検索',
            web_search: 'ウェブ検索',
            patent_drafting_tool: '特許作成分析',
            // 特許作成の動的表示名：接頭辞 + セクション名（2つを超える場合は「他N件」に折りたたむ）
            draftingPrefix: '作成：',
            draftingMore: ' 他{count}件',
            draftingSections: {
                Claims: '請求項',
                Title: '発明の名称',
                Field: '技術分野',
                Background: '背景技術',
                Summary: '発明の概要',
                Drawing_desc: '図面の説明',
                Description: '発明を実施するための形態',
                Abstract: '要約',
                Outline: 'アウトライン',
            },
            patent_rule_review_tool: '特許規則レビュー',
            extract_oa_and_generate_rejection_table: '審査意見の抽出と拒絶分析表の生成',
            extract_oa_analysis: '審査意見の抽出と拒絶分析表の生成',
            extract_oa_info: '審査意見を抽出',
            extract_raw_text: '原文テキストを抽出',
            generate_oa_strategy: '審査意見への対応戦略を生成',
            generate_oar_content: 'OARドキュメントを生成',
            render_rejection_table: '拒絶分析表を表示',
            update_rejection_table: '拒絶分析表を更新',
            validate_oa_strategy: '審査意見対応戦略を検証',
            fetch_office_action_pdf: '審査意見PDFを取得',
            fetch_historical_files: '履歴ファイルを取得',
            analyze_disclosure: '技術開示書を分析',
            novelty_creativity_evaluation: '新規性創造性評価',
            update_plan: 'プランを更新',
            read_style: '作成スタイルを読む',
            read_template: 'テンプレートを読む',
            request_user_decision: 'ユーザー決定を要求',
            load_skill: 'スキルをロード',
            inject_agent_skill: 'スキルをロード',
            load_skill_content: 'スキルをロード',
            detect_and_setup_patent_office: '特許庁の検出と設定',
            write_document: 'ドキュメントを作成',
            express_generate_reply: '応答生成',
            check_express_eligibility: '生成条件を確認',
            suggest_next_step: '次のステップを提案',
            analyze_oa_response_strategy: 'OA応答戦略を分析',
            streaming: 'ツール出力中...',
            done: 'ツール呼び出し完了',
            generate_oar_document: '審査意見応答書を生成',
            generate_image: '図面生成分析',
            convert_patent_figure: '特許図面生成',
            draw_patent_figures: '特許図面を描画',
            label_patent_figures: '特許図面を標注',
            plan_patent_drawings: '特許図面案を計画',
            spawn_agent: '技術探索',
        },

        // 新規性・進歩性評価レンダラー
        noveltyEvaluation: {
            tabPatents: '対比特許',
            tabEvaluations: '評価レポート',
            noData: 'データなし',
            parseError: 'データの解析に失敗しました',
        },

        // 特許検索結果レンダラー
        patentSearch: {
            found: '上位{count}件の関連特許',
            searchResult: '検索結果',
            expand: '展開',
            collapse: '折りたたむ',
            applicationDate: '出願日',
            publicationDate: '公開日',
            relevance: '関連度',
            parseError: 'データ解析に失敗しました',
            showDetails: '特許詳細',
            noData: 'データがありません',
            searchTypes: {
                semantic_search: 'セマンティック検索',
                structured_query: '構造化検索',
                patent_number: '特許番号検索',
            },
        },

        // フローティングウィンドウ
        floating: {
            minimize: '最小化',
            maximize: '最大化/復元',
            close: '閉じる',
        },

        // 特許詳細レンダラー
        patentDetail: {
            basicInfo: '基本情報',
            patentNumber: '特許番号',
            title: 'タイトル',
            applicationNumber: '出願番号',
            applicationDate: '出願日',
            publicationDate: '公開日',
            inventor: '発明者',
            applicant: '出願人',
            abstract: '要約',
            copySection: 'セクションをコピー',
            copyAll: 'すべてコピー',
            export: 'エクスポート',
            copySuccess: '{section} をコピーしました',
            copyFailed: 'コピーに失敗しました',
            exportSuccess: 'エクスポートに成功しました',
            exportFailed: 'エクスポートに失敗しました',
            images: '図面',
            parseError: 'データ解析に失敗しました',
            fallbackHint: '以下は元のコンテンツです：',
            textFormatError: '現在のコンテンツはテキスト形式です。会話で全文をご確認ください。',
        },

        // 論文検索結果レンダラー
        paperSearch: {
            title: '論文セマンティック検索',
            found: '{count}件の関連論文が見つかりました',
            noData: '関連論文が見つかりませんでした',
            parseError: 'データ解析に失敗しました',
            showDetails: '詳細を見る',
            authors: '著者',
            journal: 'ジャーナル',
            publishTime: '発表日',
            doi: 'DOI',
            citationCount: '引用数',
            downloadPdf: 'PDF ダウンロード',
            searchModes: {
                text: 'テキストセマンティック検索',
                paper: '類似論文検索',
                patent: '特許関連論文',
            },
        },

        // LLM リプレイ
        llmReplay: {
            title: 'リクエストボディ',
            formView: 'フォームビュー',
            jsonView: 'JSONビュー',
            basicConfig: '基本設定',
            model: 'モデル',
            modelPlaceholder: '例: claude-4.5-sonnet',
            temperature: '温度',
            maxTokens: '最大トークン数',
            stream: 'ストリーミング出力',
            reasoningEffort: '推論強度',
            selectPlaceholder: '選択してください',
            messageList: 'メッセージリスト',
            addMessage: 'メッセージを追加',
            messageIndex: 'メッセージ {index}',
            delete: '削除',
            role: 'ロール',
            rolePlaceholder: 'ロールを選択',
            content: '内容',
            contentPlaceholder: 'メッセージ内容を入力',
            jsonPlaceholder: 'JSON形式のリクエストボディを入力',
            jsonError: 'JSONフォーマットエラー: {message}',
            switchError: '切り替え不可: JSONフォーマットエラー',
            replayResult: 'リプレイ結果',
            fieldRole: 'ロール',
            fieldContent: '内容',
            finishReason: '完了理由',
            tokenUsage: 'トークン使用統計',
            promptTokens: '入力トークン:',
            completionTokens: '出力トークン:',
            totalTokens: '合計:',
            modelInfo: 'モデル情報',
            modelLabel: 'モデル:',
            createdAt: '作成日時:',
            requestId: 'リクエストID:',
            statusIdle: '未開始',
            statusReplaying: 'リプレイ中',
            statusSuccess: '成功',
            statusError: '失敗',
        },
    },
};
